export type ApiId = string;
export type DataSourceId = string;
export type EndpointId = string;
export type OperationId = string;
export type SchemaId = string;
export type CredentialId = string;
export type AdapterId = string;
